import { validateDecimal, validateDecimalOrEmpty, validateIntegerOrEmpty } from "../../../../../utils/validation"

const getShopIdError = (shopIdResult) => {
  if (!shopIdResult.readValue) {
    return `店舗が取得できませんでした : ${shopIdResult.csvValue || ''}`
  }
  return ""
}

const getProductIdError = (productIdResult) => {
  if (!productIdResult.readValue) {
    return `商品が取得できませんでした : ${productIdResult.csvValue || ''}`
  }
  return ""
}

const getOriginIdError = (originIdResult) => {
  if (!originIdResult.readValue) {
    return `産地が取得できませんでした : ${originIdResult.csvValue || ''}`
  }
  return ""
}

const getRankIdError = (rankIdResult) => {
  if (rankIdResult.status != 'SUCCEEDED') {
    
    return `等級が取得できませんでした : ${rankIdResult.csvValue || ''}`
  }
  return ""
}

const getProductClassIdError = (productClassIdResult) => {
  if (productClassIdResult.status != 'SUCCEEDED') {
    return `階級が取得できませんでした : ${productClassIdResult.csvValue || ''}`
  }
  return ""
}

const getPackingIdError = (packingIdResult) => {
  if (packingIdResult.status != 'SUCCEEDED') {
    return `荷姿が取得できませんでした : ${packingIdResult.csvValue || ''}`
  }
  return ""
}

const getWeightError = (weightResult, weightUnitIdResult) => {
  if (
    weightResult.status != 'SUCCEEDED'
      || (weightUnitIdResult.readValue && !weightResult.readValue)
      || (weightResult.readValue && !validateDecimalOrEmpty(weightResult.readValue?.toString() || ''))
  ) {
    return `重量が取得できませんでした : ${weightResult.csvValue || ''}`
  } 
  if (weightUnitIdResult.status != 'SUCCEEDED'
      || (weightResult.readValue && !weightUnitIdResult.readValue)
  ) {
    return `重量単位が取得できませんでした : ${weightUnitIdResult.csvValue || ''}`
  }
  return ""
}

const getOrderQuantityError = (quantityResult) => {
  if (
    !quantityResult.readValue
      || !validateDecimal(quantityResult.readValue.toString())
  ) {
    return `注文数量が取得できませんでした : ${quantityResult.csvValue || ''}`
  }
  return ""
}

const getPriceError = (priceResult) => {
  if (!validateIntegerOrEmpty(priceResult.readValue?.toString() || '')) {
    return `単価が取得できませんでした : ${priceResult.csvValue || ''}`
  }
  return ""
}

export const getRowCsvErrors = (result) => {
  
  const errorsArrays = [
    ["shopId", getShopIdError(result.shopId)],
    ["productId", getProductIdError(result.productId)],
    ["originId", getOriginIdError(result.originId)],
    ["rankId", getRankIdError(result.rankId)],
    ["productClassId", getProductClassIdError(result.productClassId)],
    ["packingId", getPackingIdError(result.packingId)],
    ["weight", getWeightError(result.weight, result.weightUnitId)],
    ["price", getPriceError(result.price)],
    ["orderQuantity", getOrderQuantityError(result.orderQuantity)]
  ];

  return Object.fromEntries(
    errorsArrays.filter((eArr) => eArr[1].length > 0)
  );  
}


